import React from "react";

let Pulse = React.createClass({
    getInitialState() {
        return {};
    },
    render() {

        return (
            <section className={`eo-pulse ${this.props.className || ""}`}>
                <div className="pulse-wrap">
                    <div className="circle line line-06"></div>
                    <div className="circle line line-05"></div>
                    <div className="circle line line-04"></div>
                    <div className="circle line line-03"></div>
                    <div className="circle line line-02"></div>
                    <div className="circle line line-01"></div>
                </div>
            </section>
        );
    }
});

export default Pulse;



/** WEBPACK FOOTER **
 ** ./app/views/anonymous/views/root/components/Pulse.js
 **/